import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { Configurations } from '../../Utils/Configurations';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import moment from 'moment';
import axios from 'axios';
class ForeignersDetails extends Component {

    constructor(props) {
        super(props);

        this.validacaoEmail = this.validacaoEmail.bind(this);
        this.habilitaSalvar = this.habilitaSalvar.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.validacaoDtNascimento = this.validacaoDtNascimento.bind(this);
        this.toggleModalPendencia = this.toggleModalPendencia.bind(this);
        this.carregarInfosEstrangeiro = this.carregarInfosEstrangeiro.bind(this);
        this.toggleSucessoNovoCadastro = this.toggleSucessoNovoCadastro.bind(this);
        this.toggleModalLink = this.toggleModalLink.bind(this);
        this.enviarLink = this.enviarLink.bind(this);

        this.state = {
            nomeCompleto: '',
            dtNascimento: '',
            email: '',
            telefone: '',
            descricao: '',
            origem: '',
            temAlteracao: false,
            isLoadingAlteracoes: false,
            sucessoAlteracao: false,
            membroSgi: true,
            isLoadingCadastro: false,
            novoCadastro: this.props.match.params.idEstrangeiro === "novo-cadastro",
            modalSucessoNovoCadastro: false,
            openModalLink: false,
            isLoadingEnviarLink: false,



        }

        this.Configurations = new Configurations();
    }

    componentWillMount() {
        this.setState({
            idEstrangeiro: this.props.match.params.idEstrangeiro
        })
        if (!this.state.novoCadastro) {
            this.carregarInfosEstrangeiro();
        }
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    onChangeInput(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        const _name = e.target.name;
        this.setState({ [_name]: e.target.value });
    }

    validacaoDtNascimento(dtNasc) {
        // First check for the pattern
        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dtNasc))
            return false;

        // Parse the date parts to integers
        var parts = dtNasc.split("/");
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month === 0 || month > 12)
            return false;

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    }


    validacaoEmail(inputEmail) {
        const _usuario = inputEmail.substring(0, inputEmail.indexOf("@"));
        const _dominio = inputEmail.substring(inputEmail.indexOf("@") + 1, inputEmail.length);

        if ((_usuario.length >= 1) &&
            (_dominio.length >= 3) &&
            (_usuario.search("@") === -1) &&
            (_dominio.search("@") === -1) &&
            (_usuario.search(" ") === -1) &&
            (_dominio.search(" ") === -1) &&
            (_dominio.search(".") !== -1) &&
            (_dominio.indexOf(".") >= 1) &&
            (_dominio.lastIndexOf(".") < _dominio.length - 1)) {
            return true;
        }
        else return false;
    }

    habilitaSalvar() {
        const _nomeValido = this.state.nomeCompleto.trim() !== '';
        const _dataNascimentoValida = this.validacaoDtNascimento(this.state.dtNascimento);
        const _emailValido = this.validacaoEmail(this.state.email);

        const _infosObrigatorias = [
            { campo: "Nome completo", valido: _nomeValido },
            { campo: "Data de nascimento", valido: _dataNascimentoValida },
            { campo: "Email", valido: _emailValido },

        ];

        const _pendencias = _infosObrigatorias.filter(item => !item.valido);
        const _infos = _nomeValido * _dataNascimentoValida * _emailValido;

        this.setState({ habilitaSalvar: _infos }, () => this.salvarAlteracoes(_pendencias))
    }

    salvarAlteracoes(_pend) {

        if (this.state.habilitaSalvar) {
            this.setState({ isLoadingAlteracoes: true })
            const arrayDtNasc = this.state.dtNascimento.split("/"),
                dia = arrayDtNasc[0],
                mes = arrayDtNasc[1],
                ano = arrayDtNasc[2];
            const dtFormat = `${ano}-${mes}-${dia}`
            const _salvarEstrangeiro = {
                nome: this.state.nomeCompleto,
                dtNascimento: moment(dtFormat).format(),
                email: this.state.email,
                telefone: this.state.telefone,
                descricao: this.state.descricao,
                membroSgi: this.state.membroSgi === "true" || this.state.membroSgi === true,
                origem: this.state.origem
            }

            if (this.state.novoCadastro) {
                axios.post(this.Configurations.apiBasePath + `/estrangeiro`, _salvarEstrangeiro).then(response => {
                    this.setState({
                        sucessoAlteracao: true,
                        temAlteracao: false,
                    })
                    this.toggleSucessoNovoCadastro();
                }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
            } else {
                const id = this.props.match.params.idEstrangeiro;
                axios.put(this.Configurations.apiBasePath + `/estrangeiro/${id}`, _salvarEstrangeiro).then(response => {
                    this.setState({
                        sucessoAlteracao: true,
                        temAlteracao: false,
                    })
                }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
            }
        } else {
            this.setState({ pendencias: _pend }, () => this.toggleModalPendencia());
        }
    }

    toggleSucessoNovoCadastro() {
        if (this.state.modalSucessoNovoCadastro) {
            this.setState({ modalSucessoNovoCadastro: false }, () =>
                window.history.go(-1)
            );
        } else this.setState({ modalSucessoNovoCadastro: true })
    }

    toggleModalPendencia() {
        this.setState({ modalPendencia: !this.state.modalPendencia })
    }

    carregarInfosEstrangeiro() {
        this.setState({ isLoadingCadastro: true })
        axios.get(this.Configurations.apiBasePath + `/estrangeiro?idEstrangeiro=${this.props.match.params.idEstrangeiro}`).then(response => {
            const dados = response.data.data[0];
            this.setState({
                nomeCompleto: dados.nome,
                dtNascimento: moment(dados.dtNascimento).format('DD/MM/YYYY'),
                email: dados.email,
                telefone: dados.telefone,
                descricao: dados.descricao,
                membroSgi: dados.membroSgi,
                origem: dados.origem,
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingCadastro: false }));
    }

    enviarLink() {
        // const id = this.props.match.params.idEstrangeiro;
        this.setState({ isLoadingEnviarLink: true })
        axios.post(this.Configurations.apiBasePath + `/token-estrangeiro/${this.props.match.params.idEstrangeiro}`)
            .then(response =>
                this.setState({ openModalLink: true }))
            .catch(this.handleError)
            .finally(() => {
                this.setState({ isLoadingEnviarLink: false });
            }
            )
    }
    toggleModalLink() {
        this.setState({
            openModalLink: !this.state.openModalLink
        })
    }


    render() {
        return (
            <div className="row cadastro-usuarios-especiais px-2 px-lg-2 no gutters" >
                {
                    this.state.isLoadingCadastro ? (
                        <div className="col-12 text-center py-5">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                    ) : (
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12">
                                    <div className="row pt-1 pb-2 border-bottom border-dark no-gutters">
                                        <div className="col-8 text-left">
                                            <h3 className="d-none d-lg-block">Usuário especial - {this.state.novoCadastro ? 'Novo Cadastro' : "Detalhes"}</h3>
                                        </div>
                                        <div className="col-2 text-right">
                                            {!this.state.novoCadastro &&
                                                <React.Fragment>
                                                    {this.state.isLoadingEnviarLink ? (
                                                        <div className="spinner-border text-primary" role="status" />
                                                    ) : (
                                                        <button onClick={this.enviarLink} className="btn btn-outline-success">Enviar link</button>
                                                    )}
                                                </React.Fragment>
                                            }
                                        </div>
                                        <div className="col-2 text-right">
                                            <button onClick={() => this.props.history.push(`/usuarios-especiais/lista`)} className="btn btn-outline-secondary">voltar</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 py-3 text-left">
                                    <small><small>(*)</small> informações obrigatórias</small>
                                </div>
                                <div className="col-12">
                                    <div className="row no-gutters">
                                        <div className="col-12 py-2">
                                            <label>Nome completo<sup><small>(*)</small></sup></label>
                                            <input name="nomeCompleto" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.nomeCompleto} autoComplete="no-show" />
                                        </div>
                                        <div className="col-3 py-3 pr-4">
                                            <label>Data de nascimento<sup><small>(*)</small></sup></label>
                                            <InputMask
                                                type="tel"
                                                className="form-control"
                                                maskChar=""
                                                mask="99/99/9999"
                                                id="numDtNascimento"
                                                name="dtNascimento"
                                                placeholder="DD/MM/AAAA"
                                                value={this.state.dtNascimento}
                                                onChange={this.onChangeInput}
                                                autoComplete="disabled"
                                            />
                                        </div>
                                        <div className="col-4 py-3 px-4 pl-4">
                                            <label>E-mail<sup><small>(*)</small></sup></label>
                                            <input name="email" type="email" className="form-control" onChange={this.onChangeInput} value={this.state.email} autoComplete="no-show" />
                                        </div>
                                        <div className="col-4 py-3 px-4 pl-4">
                                            <label>Telefone</label>
                                            <input name="telefone" type="tel" className="form-control" onChange={this.onChangeInput} value={this.state.telefone} autoComplete="no-show" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 py-3">
                                            <label>Descrição</label>
                                            <textarea rows={3} name="descricao" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.descricao} autoComplete="no-show" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-3 py-3">
                                            <label>Membro SGI</label>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="membroSgi" id="sim" checked={this.state.membroSgi.toString() === "true"} value={true} onChange={this.onChangeInput} />
                                                <label className="form-check-label" htmlFor="sim">Sim</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="membroSgi" id="nao" checked={this.state.membroSgi.toString() === "false"} value={false} onChange={this.onChangeInput} />
                                                <label className="form-check-label" htmlFor="nao">Não</label>
                                            </div>
                                        </div>
                                        <div className="col-3 py-3">
                                            <label>Origem</label>
                                            <input name="origem" type="text" className="form-control" autoComplete="no-show" onChange={this.onChangeInput} value={this.state.origem} placeholder="Ex: SGI Portugal" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-lg-12 py-5 text-center">
                                            {this.state.isLoadingAlteracoes ? (
                                                <div className="spinner-border text-primary" role="status" />
                                            ) : (
                                                <>
                                                    {this.state.sucessoAlteracao && !this.state.temAlteracao && (
                                                        <span className="text-success mr-3"><i>Alterações salvas com sucesso.</i></span>
                                                    )}

                                                    {this.state.temAlteracao && (
                                                        <span className="text-danger mr-3"><i>As alterações ainda não foram salvas.</i></span>
                                                    )}
                                                    <button onClick={this.habilitaSalvar} disabled={!this.state.temAlteracao} className="btn btn-outline-success">salvar alterações</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <Modal isOpen={this.state.modalPendencia} toggle={this.toggleModalPendencia}>
                                    <ModalHeader toggle={this.toggleModalPendencia}>Campos obrigatórios</ModalHeader>
                                    <ModalBody>
                                        <p>Por favor, preencha o(s) seguinte(s) campo(s) obrigatório(s):</p>
                                        <ul>
                                            {this.state.pendencias && this.state.pendencias.map((item, index) => {
                                                return <li key={`campo-${index}`}>{item.campo} (Informação inválida)</li>
                                            })}
                                        </ul>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="secondary" onClick={this.toggleModalPendencia}>ok</Button>
                                    </ModalFooter>
                                </Modal>
                                <Modal isOpen={this.state.modalSucessoNovoCadastro} toggle={this.toggleSucessoNovoCadastro}>
                                    <ModalHeader toggle={this.toggleSucessoNovoCadastro}>
                                        Novo cadastro
                                    </ModalHeader>
                                    <ModalBody>
                                        <p className="m-0">Novo cadastro realizado com sucesso!</p>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="success" onClick={() => this.props.history.push(`/usuarios-especiais/lista`)}>ok</Button>
                                    </ModalFooter>
                                </Modal>
                                <Modal size="sm" isOpen={this.state.openModalLink} toggle={this.toggleModalLink}>
                                    <ModalBody toggle={this.toggleModalLink}>
                                        Link enviado com sucesso!
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="success" onClick={this.toggleModalLink}>ok</Button>
                                    </ModalFooter>
                                </Modal>

                                <ErrorModal
                                    isOpen={this.state.hasError}
                                    message={this.state.errorMessage}
                                    closeErrorModal={this.closeErrorModal}
                                />

                            </div>
                        </div>
                    )
                }
            </div>
        )
    }
}
export default ForeignersDetails;




